import { CmsImageForUrl } from 'src/components/images/CmsImageForUrl';
import CSSPoster, { CSSPosterMissing, CSSPosterSizer, CSSPosterWrapper, type SPosterMissingProps } from 'src/components/posterrow/CSSPoster';
import PlaySvg from 'src/components/svg/PlaySvg';
import { MovieClip } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';

//#region [Props]
type TrailerPosterProps = {
	movieClip: MovieClip;
	className?: string;
};
//#endregion

//#region [Component]
export default function TrailerPoster({ movieClip, className }: TrailerPosterProps) {
	return <SArticle className={className}>
		<SPosterWrapper $isPosterMissing={true}>
			<SPosterLink href={`#trailer${movieClip.id}`}>
				<SPlaySvg />
				<CmsImageForUrl imageUrl={movieClip.sanityImagePosterUrl!} alt={`Plakat for ${movieClip.movieTitle}`} width={227} unoptimized isPosterAspect/>
			</SPosterLink>
		</SPosterWrapper>
		<h1><SPosterTitleLink href={`#trailer${movieClip.id}`}>{movieClip.movieTitle}</SPosterTitleLink></h1>
	</SArticle>;
}
//#endregion

//#region [Styles]
const SArticle = styled.article`
	${CSSPoster}

	&:hover {
		svg {
			width: 40%;
		}
	}
`;

const SPosterWrapper = styled.div<SPosterMissingProps>`
	${CSSPosterWrapper}

	${props => props.$isPosterMissing ? CSSPosterMissing : ""}


`;

const SPosterLink = styled.a`
	${CSSPosterSizer}
`;

const SPosterTitleLink = styled.a``;

const SPlaySvg = styled(PlaySvg)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	transition: width 0.5s;
	width: 30%;
	z-index: 1;
`;
//#endregion